import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Home from './Home.js'
import Chat from './Chat.js';

function App() {
  return (
    <Router>
      <Switch>
        <Route exact path='/chat/:name/:room' component={Chat}></Route>
        <Route exact path='/' component ={Home}></Route>
      </Switch>
    </Router>
  );
}

export default App;
